import { FRONTEND_SERVER, SERVER_URL } from '../../../config';

export const uiCategorySettings = {
    freelancer_invitation: {
        color: '#1ebf1e',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    freelancer_published: {
        color: '#387FFB',
        url: `${SERVER_URL}/freelancer/%s/`,
        pkName: 'object_id',
    },
    freelancer_booked: {
        color: '#387FFB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    freelancer: {
        color: '#387FFB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    client_booked_onefreelancer: {
        color: '#008000',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    client_job_request_changed: {
        color: '#f49e42',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    client_feedback_request: {
        color: '#666699',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    booking_cancelled: {
        color: '#999999',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    admin_push_message: {
        color: '#c122d6',
        url: null,
    },
    client_reminder: {
        color: '#c122d6',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    freelancer_reminder: {
        color: '#c122d6',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    'shiftmanagement.jobnotfilled': {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    'shiftmanagement.jobdelegated': {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    'shiftmanagement.backupnotused': {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'additional_object_id',
    },
    'shiftmanagement.bookingautomatched': {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'additional_object_id',
    },
    'shiftmanagement.booking_self_cancelled': {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'additional_object_id',
    },
    'tracking_issue.late': {
        color: '#ff0000',
        url: `${FRONTEND_SERVER}/operations/locationtracking/map/%s/`,
        pkName: 'object_id',
    },
    'tracking_issue.no_gps': {
        color: '#ff0000',
        url: `${FRONTEND_SERVER}/operations/locationtracking/map/%s/`,
        pkName: 'object_id',
    },
    'tracking_issue.device_offline': {
        color: '#ff0000',
        url: `${FRONTEND_SERVER}/operations/locationtracking/map/%s/`,
        pkName: 'object_id',
    },
    'tracking_issue.gps_disabled': {
        color: '#ff0000',
        url: `${FRONTEND_SERVER}/operations/locationtracking/map/%s/`,
        pkName: 'object_id',
    },
    'clocking_issue.clockin_late': {
        color: '#ffa64d',
        url: `${FRONTEND_SERVER}/operations/bookings/expanded/%s/clockin-out/%s?search=BK%s&getall=1`,
        pkName: 'object_id',
    },
    'clocking_issue.clockin_far': {
        color: '#ffa64d',
        url: `${FRONTEND_SERVER}/operations/bookings/expanded/%s/clockin-out/%s?search=BK%s&getall=1`,
        pkName: 'object_id',
    },
    'clocking_issue.clockin_missing': {
        color: '#ffa64d',
        url: `${FRONTEND_SERVER}/operations/bookings/expanded/%s/clockin-out/%s?search=BK%s&getall=1`,
        pkName: 'object_id',
    },
    'clocking_issue.clockout_late': {
        color: '#ffa64d',
        url: `${FRONTEND_SERVER}/operations/bookings/expanded/%s/clockin-out/%s?search=BK%s&getall=1`,
        pkName: 'object_id',
    },
    bad_feedback: {
        color: '#2eb82e',
        url: `${FRONTEND_SERVER}/operations/bookings/expanded/%s/?search=BK%s&getall=1`,
        pkName: 'object_id',
    },
    freelancer_request_departure_confirmation: {
        color: '#2eb82e',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    upcoming_interview: {
        color: '#2eb82e',
        url: `${SERVER_URL}/dashboard/admin/induction-session-calendar/%s/`,
        pkName: 'object_id',
    },
    'freelancer.dvla_check_expiring': {
        color: '#2eb82e',
        url: `${SERVER_URL}/freelancer/admin/documents/?type=DV`,
    },
    'freelancer.booking_removed': {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    'freelancer.available_to_neighbouring_offices': {
        color: '#2C7CBB',
        url: `${FRONTEND_SERVER}/operations/freelancer/%s/`,
        pkName: 'object_id',
    },
    freelancers_replaced: {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    'client_shiftmanagement.job_cancelled': {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    'client_shiftmanagement.job_changed': {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    client_job_request_confirmed: {
        color: '#2C7CBB',
        url: `${SERVER_URL}/job/%s/`,
        pkName: 'object_id',
    },
    'client_tracking_issue.lateness': {
        color: '#ff0000',
        url: `${FRONTEND_SERVER}/operations/locationtracking/map/%s/`,
        pkName: 'object_id',
    },
    'client_clocking.clockout_confirm': {
        color: '#ffa64d',
        url: `${FRONTEND_SERVER}/operations/bookings/expanded/%s/clockin-out/%s?search=BK%s&getall=1`,
        pkName: 'object_id',
    },
    'client_feedbacks.missing_feedback': {
        color: '#666699',
        url: `${FRONTEND_SERVER}/operations/bookings/expanded/%s/?getall=1`,
        pkName: 'object_id',
    },
};
